import script from "./GameControl.vue?vue&type=script&setup=true&lang=js"
export * from "./GameControl.vue?vue&type=script&setup=true&lang=js"

import "./GameControl.vue?vue&type=style&index=0&id=2d60fb54&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d60fb54"]])

export default __exports__